<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style>
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue